export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5203.45e5aa26.jpg";